import BaseClass from "../BaseClass.js";

export default class AutoloadFilter extends BaseClass {

    constructor(element) {
        super(element);

        this.filterUrl = this.$element.attr('data-url');
        this.alwaysVisible = this.$element.attr('data-always-visible') !== undefined;
        this.autoloadContainer = null;
        this.$formElement = null;
        this.currentFilterGroup = null;
        this.additionalJSONData = '';

        this.init();
    }

    init() {
        this.assignAutoLoadContainer();
        this.initForm();
        this.initClickFilter();

        const additionalJSONData = this.$element.data('additional-json');
        if (additionalJSONData != undefined) {
            this.additionalJSONData = additionalJSONData;
        }

        let mySelf = this;

        this.contentLoadedListener = function (event, data) {
            mySelf.onContentLoaded(event, data);
        };

        $(document).on('content:loaded', this.contentLoadedListener);
    }

    onContentLoaded(event, data) {

        let showFilter = false;
        if (this.autoloadContainer !== null && this.autoloadContainer != undefined && data !== undefined) {
            if (this.autoloadContainer.$element.attr('id') === data.elementID) {
                let $nextLoadMarker = this.$element.find('[data-type="autoloadNext"]');

                if ($nextLoadMarker.length === 1) {
                    showFilter = true;
                }
            }
        }

        if (this.alwaysVisible || showFilter) {
            this.$element.find('.filter-elements').removeClass('hidden');
        }
    }

    initClickFilter() {
        let mySelf = this;
        this.$element.find('[data-type="filter"]').on('click', function (event) {

                let filterName = $(this).attr('data-filtername');
                let activfilterValue = $(this).attr('data-activ-filter-value');
                let notactivfilterValue = $(this).attr('data-notactiv-filter-value');
                let clickCount = $(this).attr('data-click-count');

                if (clickCount === undefined) {
                    clickCount = 0;
                }

                clickCount = parseInt(clickCount);
                clickCount++;

                if (clickCount < 3) {
                    $(this).attr('data-click-count', clickCount);
                    $(this).attr('data-activ-filter-value', notactivfilterValue);
                    $(this).attr('data-notactiv-filter-value', activfilterValue);

                    if (clickCount == 1) {
                        $(this).addClass('arrow-down');
                        $(this).removeClass('arrow-up');
                    } else {
                        $(this).addClass('arrow-up');
                        $(this).removeClass('arrow-down');
                    }

                    let postData = filterName + '=' + activfilterValue;

                    if (mySelf.autoloadContainer !== null) {
                        mySelf.autoloadContainer.setFilterData(mySelf.filterUrl, postData);
                    }

                } else {
                    $(this).attr('data-click-count', 0);
                    $(this).removeClass('arrow-down');
                    $(this).removeClass('arrow-up');
                    if (mySelf.autoloadContainer !== null) {
                        mySelf.autoloadContainer.removeFilterValue(mySelf.filterUrl, filterName);
                    }
                }
            }
        );


    }

    initForm() {
        let $formElement = this.$element.find('FORM').first();

        if ($formElement.length == 1) {

            let mySelf = this;
            this.$formElement = $formElement;
            this.$formElement.on('submit', function (event) {
                const $submitter = $(event.originalEvent.submitter);
                let ignore = $submitter.data('autofilter-ignore');

                if (ignore == undefined) {
                    ignore = false;
                }

                if (!ignore) {
                    event.preventDefault();
                    mySelf.executeFilter(event);
                    return false;
                }
            });

            this.$formElement.find('input[data-close-mobile-keyboard]').keydown(function (event) {
                if (event.key === "Enter" || event.keyCode === 13) {
                    let closeMobileKeyboard = $(this).data('close-mobile-keyboard')
                    if (closeMobileKeyboard) {
                        $(this).blur();
                        event.preventDefault();
                    }
                }
            });

            // @TODO [aboplaene_bearbeiten]: :not([data-autofilter-ignore]) und [data-on-change!="false"] machen das gleiche, eins kann raus
            // todo eigenschaft setzen wenn erwünscht, nicht anders herum
            // Attribut data-autofilter-ignore schließt das Input-Element aus Liste der Filter-Trigger aus
            this.$formElement.find('INPUT[data-on-change!="false"]:not([data-autofilter-ignore])').on('change', function (event) {
                event.preventDefault();
                mySelf.executeFilter(event);
            });
            // Attribut data-autofilter-ignore schließt das Select-Element aus Liste der Filter-Trigger aus
            this.$formElement.find('SELECT[data-on-change!="false"]:not([data-autofilter-ignore])').on('change', function (event) {
                event.preventDefault();
                mySelf.executeFilter(event);
            });

            this.$formElement.find('a[data-pagination]').on('click', function (event) {
                event.preventDefault();
                mySelf.executeFilter(event);
            });

            this.$formElement.find('a[data-clear-input]').on('click', function (event) {
                event.preventDefault();
                $(this).closest('.input-group').find('input').val('');
                mySelf.executeFilter(event);
            });

            // Zeitproblem, AutoFilter feuert bevor BaseSelect die Felder aktualisiert hat
            this.$formElement.find('SELECT.base-select').on('change', function (event) {
                event.preventDefault();
                setTimeout(function () {
                    mySelf.executeFilter(event);
                }, 250);
            });

            this.$formElement.find('button[data-clear]').on('click', function (event) {
                event.preventDefault();
                mySelf.$formElement.trigger('reset');
                mySelf.executeFilter(event);
            });
        }
    }

    executeFilter(event) {
        const enableFilterGroups = this.$element.data('filter-group');

        if (enableFilterGroups) {
            this.updateFilterGroups(event);
        }

        const postData = new URLSearchParams(this.$formElement.serialize())

        if (this.additionalJSONData) {
            for (const key in this.additionalJSONData) {
                postData.append(key, this.additionalJSONData[key]);
            }
        }

        if (this.autoloadContainer !== null) {
            this.autoloadContainer.setFilterData(this.filterUrl, postData, true);
        }
    }

    assignAutoLoadContainer() {
        let $autoloadContainer = this.$element.find('[data-type="autoload"]').get(0);

        if ($autoloadContainer != undefined) {
            this.autoloadContainer = $autoloadContainer.jsObject;
            this.autoloadContainer.utils.filter = this;
        }
    }

    setFilterUrl(url) {
        this.$element.attr('data-url', url);
        this.filterUrl = url;
    }

    resetForm() {
        if (this.$formElement !== null) {
            this.$formElement.trigger('reset');
        }
    }

    /**
     * Bei Auswahl einer Filtergruppe Sichtbarkeit der Filter wechseln.
     *
     * @param event
     */
    updateFilterGroups(event) {
        const $target = $(event.target);

        if ($target.data('is-filter') !== true) {
            return;
        }

        let selectedFilterGroup;
        if ($target.is('select')) {
            selectedFilterGroup = $target.find('option:selected').data('filter-group');
        } else {
            selectedFilterGroup = $target.data('filter-group');
        }

        if (this.currentFilterGroup != selectedFilterGroup) {
            const $listFilter = this.$element.find('.subscription-list-filter');
            const $formElements = $listFilter.find(':input').filter(function () {
                const $this = $(this);

                return $this.is('[data-filter-group]') || $this.has('[data-filter-group]');
            });

            const $disabledFormElements = $formElements.filter(function () {
                const $this = $(this);
                const filterGroup = $this.data('filter-group');

                if (filterGroup == undefined) {
                    return false;
                }

                return !filterGroup.split(',').includes(selectedFilterGroup ?? '');
            });
            const $enabledFormElements = $formElements.not($disabledFormElements);

            const $options = $formElements.not($target).find('option');
            const $disabledOptions = $options.filter(function () {
                const $this = $(this);
                const filterGroup = $this.data('filter-group');

                if (filterGroup == undefined) {
                    return false;
                }

                return !filterGroup.split(',').includes(selectedFilterGroup ?? '');
            });
            const $enabledOptions = $options.not($disabledOptions);

            $enabledFormElements.prop('disabled', false);
            $disabledFormElements.prop('disabled', true);

            $formElements.each(function () {
                const $this = $(this);
                const container = $this.data('filter-container');

                let $container = $this;
                if (container != undefined) {
                    $container = $this.parents(container);
                }

                if ($disabledFormElements.filter($this).length > 0) {
                    $container.addClass('hidden');
                } else {
                    $container.removeClass('hidden');
                }
            });

            $enabledFormElements.removeClass('hidden');
            $disabledFormElements.addClass('hidden');

            $enabledOptions.prop('disabled', false);
            $enabledOptions.removeClass('hidden');
            $disabledOptions.prop('disabled', true);
            $disabledOptions.addClass('hidden');

            this.currentFilterGroup = selectedFilterGroup;
        }

    }

    destroyListener() {
        $(document).off('content:loaded', this.contentLoadedListener);
    }
}